import Vue from 'vue'
import Router from 'vue-router'
import store from './stores'


import authGuard from './authGuard'
import { isInSchedule } from "@/services/schedule.service"

import get from "lodash/get";
import { handOverMenu } from "@/stores/modules/menu";

// DEV-11553: iPhone home-screen icon. index.html sets Snappy's apple-touch-icon; only the few groups
// with their own icons in public/img/{gid}/ swap theirs in. Checked by loading it first: for any
// other group that path is the SPA's index.html, which used to replace the icon with nothing.
const DEFAULT_TOUCH_ICON = process.env.BASE_URL + 'apple-touch-icon.png'
function setGroupTouchIcon(gid) {
  const link = document.querySelector('link[rel="apple-touch-icon"]')
  if (!link) return
  link.href = DEFAULT_TOUCH_ICON
  link.dataset.gid = gid
  const groupIcon = process.env.BASE_URL + 'img/' + gid + '/icon-192x192.png'
  const probe = new Image()
  probe.onload = () => { if (link.dataset.gid === gid) link.href = groupIcon } // still this group's page
  probe.src = groupIcon
}

Vue.use(Router)

const path = pathName => {
  return `${pathName}`
}

const setMetaInfo = (store, to) => {
  // leaving to simplify urgent change DEV-2409
};

const isMenuAvailableWithScheduledTime = (menu, checkoutInfo, storeTimeZone) => {
  if (!menu.schedule || !menu.schedule.items || menu.schedule.items.length === 0) {
    return true; 
  }

  const scheduledDate = checkoutInfo.scheduledDay;
  const scheduledTime = checkoutInfo.scheduledTime;

  if (scheduledTime === 'now') {
    const timeZone = storeTimeZone || "America/Toronto";
    const now = new Date(
      new Date().toLocaleString("en-US", { timeZone })
    );
    return isInSchedule(menu.schedule.items, now, 0);
  }

  // Validate both scheduledDate and scheduledTime
  if (!scheduledDate || !scheduledTime) {
    return false;
  }
  const targetDate = new Date(scheduledDate);
  const targetTime = new Date(scheduledTime);
  if (isNaN(targetDate.getTime()) || isNaN(targetTime.getTime())) {
    return false;
  }
  const targetDay = targetDate.toLocaleString('en-US', { weekday: 'long' }).toUpperCase();
  const targetHour = targetTime.getHours() + targetTime.getMinutes() / 60;

  return menu.schedule.items.some(schedule => {
    if (schedule.type === 'DAYS_OF_WEEK' && schedule.days.includes(targetDay)) {
      return schedule.timeRange.some(range => {
        return targetHour >= range.start && targetHour <= range.end;
      });
    }
    return false;
  });
};

const getVisibleMenus = async (filteredMenus, storeId) => {
  if (!filteredMenus || filteredMenus.length === 0) return [];

  try {
    const fullMenus = await Promise.all(filteredMenus.map(async menu => {
      try {
        const res = await Vue.prototype.$api.get(`/menu/${menu.code}`, {
          headers: { storeId }
        });
        // DEV-11345: the store page's fetchAllMenus reuses this download once instead of repeating it.
        handOverMenu(storeId, menu.code, res.data);
        return res.data;
      } catch (e) {
        console.error('Error fetching menu details for', menu.code, e);
        return menu; 
      }
    }));

    const visibleMenus = filteredMenus.filter(menu => {
      const fullMenu = fullMenus.find(fm => fm.code === menu.code);
      if (!fullMenu || !fullMenu.menuGroups || fullMenu.menuGroups.length === 0) {
        return true; 
      }
      return fullMenu.menuGroups.some(group => group.hidden !== true);
    });

    return visibleMenus;
  } catch (error) {
    console.error('Error in getVisibleMenus:', error);
    return filteredMenus;
  }
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: path('/'),
      name: 'home',
      component: () => import(/* webpackChunkName: "home-page" */ './views/HomePage.vue'),
      meta: {
        auth: false,
        pageTitle: 'Home'
      }
    },
    // {
    //   path: path('/detail/:gid'),
    //   name: 'group',
    //   component: () => import(/* webpackChunkName: "group-page" */ './views/GroupPage.vue'),
    //   meta: {
    //     auth: false,
    //     manifest: true
    //   },
    //   beforeEnter(to, from, next) {
    //     store.dispatch('setGroupStore', { gid: to.params.gid })
    //       .then(() => {
    //         const metaInfo = setMetaInfo(store, to);
    //         to.meta.metaInfo = metaInfo;
    //         store.dispatch('batchFetchStoresForGroup')
    //       })
    //       .finally(() => {
    //         next()
    //       })
    //   }
    // },
    {
      path: path('/g/:groupSlug/:gid/'),
      name: 'group',
      component: () => import(/* webpackChunkName: "group-page" */ './views/GroupPage.vue'),
      meta: {
        auth: false,
        manifest: true
      },
      beforeEnter(to, from, next) {
        store.dispatch('setGroupStore', { gid: to.params.gid })
          .then(() => {
            const metaInfo = setMetaInfo(store, to);
            to.meta.metaInfo = metaInfo;
            store.dispatch('batchFetchStoresForGroup')
          })
          .finally(() => {
            next()
          })
      }
    },
    {
      path: path('/snappy/detail/:gid/:sid/m/:mid/register'),
      name: 'register',
      component: () => import(/* webpackChunkName: "register" */ './views/RegisterPage.vue'),
      meta: {
        auth: false,
        pageTitle: 'Register'
      }
    },
    // {
    //   path: path('/detail/:gid/:sid'),
    //   name: 'menu-selection',
    //   component: () => import(/* webpackChunkName: "menu-selection-page" */ './views/MenuSelectionPage.vue'),
    //   meta: {
    //     auth: false,
    //     manifest: true
    //   },
    //   beforeEnter(to, from, next) {
    //     const metaInfo = setMetaInfo(store, to);
    //     to.meta.metaInfo = metaInfo;
    //     next();
    //   }
      // beforeEnter(to, from, next) {
      //   store.dispatch('fetchStore', { gid: to.params.gid, sid: to.params.sid })
      //     .then(() => {
      //       const metaInfo = setMetaInfo(store, to);
      //       to.meta.metaInfo = metaInfo;
      //     })
      //     .finally(() => {
      //       next()
      //     })
      // }
    // },
    // Update the menu-selection route's beforeEnter hook:
    {
      path: path('/r/:restaurantSlug/:sid'),
      name: 'menu-selection',
      component: () => import(/* webpackChunkName: "menu-selection-page" */ './views/MenuSelectionPage.vue'),
      meta: {
        auth: false,
        manifest: true
      },
      async beforeEnter(to, from, next) {
        if (to.query.direct === 'true' && from.name === 'group') {
          const sid = to.params.sid;
          try {
            if (!store.getters.getStore || store.getters.getStore.storeId !== sid) {
              await store.dispatch('fetchStore', {
                gid: store.getters.getStore && store.getters.getStore.groupId,
                sid
              });
            }
            
            await store.dispatch('fetchLiteMenus');
            // Use all menus instead of pre-filtered by current time
            const allMenus = store.getters.getMenus || [];
            const liteMenus = store.getters.getLiteMenus || [];
            const checkoutInfo = store.getters.getCheckoutInfo;
            const storeTimeZone = store.getters.getStore && store.getters.getStore.timeZone;
            
            let filteredMenus = allMenus.filter(menu => {
              const channelAllowed = menu.channels && menu.channels.length 
                ? menu.channels.includes("ONLINE") 
                : true;
              
              const liteMenuExists = liteMenus.some(liteMenu => liteMenu.code === menu.code);
              
              return channelAllowed && liteMenuExists;
            });
            
            const hasScheduledTime = checkoutInfo && (
              checkoutInfo.scheduledTime === 'now' ||
              (checkoutInfo.scheduledTime && checkoutInfo.scheduledDay)
            );
            
            filteredMenus = filteredMenus.filter(menu => {
              if (hasScheduledTime) {
                return isMenuAvailableWithScheduledTime(menu, checkoutInfo, storeTimeZone);
              } else {
                if (!menu.schedule || !menu.schedule.items || menu.schedule.items.length === 0) {
                  return true;
                }
                const timeZone = storeTimeZone || "America/Toronto";
                const now = new Date(new Date().toLocaleString("en-US", { timeZone }));
                return isInSchedule(menu.schedule.items, now, 0);
              }
            });
            const visibleMenus = await getVisibleMenus(filteredMenus, sid);
            if (visibleMenus.length === 1) {
              await store.dispatch('ensureStoreCart');
              await store.dispatch('fetchStoreDetails', { sid, mid: visibleMenus[0].code });
              
              const referrerParam = to.query.referrer ? { referrer: to.query.referrer } : {};
              const targetRoute = {
                name: 'store',
                params: {
                  sid,
                  mid: visibleMenus[0].code,
                  restaurantSlug: store.getters.getStore.slug,
                  ...referrerParam
                },
                query: {
                  ...to.query,
                  skipBeforeEnter: true
                }
              };
              
              localStorage.setItem('forcePopup', JSON.stringify(true));
              if (referrerParam || to.query.referrer) {
                localStorage.setItem('forcePopupReferral', JSON.stringify(true));
              }
              
              next(targetRoute);
              return;
            }
          } catch (error) {
            console.error('HAHAHA - Error checking menus in direct navigation:', error);
          }
          
          const metaInfo = setMetaInfo(store, to);
          to.meta.metaInfo = metaInfo;
          localStorage.removeItem('preventRouterLoop');
          sessionStorage.removeItem('skipStoreReload');
          next();
          return;
        }

        if (from.name === 'menu-selection' && from.params.sid === to.params.sid) {
          sessionStorage.removeItem('skipStoreReload');
          next();
          return;
        }
        
        const sid = to.params.sid;
        if (!sid || sid === 'null' || (isNaN(sid) && sid.length < 3)) {
          console.warn('Invalid store ID in menu-selection route:', sid);
          next({
            name: '404'
          });
          return;
        }

        try {
          if (to.query.tid) {
            await store.dispatch("setTableId", to.query.tid);
            store.dispatch("setOrderType", "DINE_IN");
          }
          if (!store.getters.getStore || store.getters.getStore.storeId !== sid) {
            await store.dispatch('fetchStore', {
              gid: store.getters.getStore && store.getters.getStore.groupId,
              sid
            });
          }
          
          await store.dispatch('fetchLiteMenus');
          const allMenus = store.getters.getMenus || [];
          const liteMenus = store.getters.getLiteMenus || [];
          const checkoutInfo = store.getters.getCheckoutInfo;
          const storeTimeZone = store.getters.getStore && store.getters.getStore.timeZone;
          
          let filteredMenus = allMenus.filter(menu => {
            const channelAllowed = menu.channels && menu.channels.length 
              ? menu.channels.includes("ONLINE") 
              : true;
            
            const liteMenuExists = liteMenus.some(liteMenu => liteMenu.code === menu.code);
            
            return channelAllowed && liteMenuExists;
          });
          
          const hasScheduledTime = checkoutInfo && (
            checkoutInfo.scheduledTime === 'now' ||
            (checkoutInfo.scheduledTime && checkoutInfo.scheduledDay)
          );
          
          filteredMenus = filteredMenus.filter(menu => {
            if (hasScheduledTime) {
              return isMenuAvailableWithScheduledTime(menu, checkoutInfo, storeTimeZone);
            } else {
              if (!menu.schedule || !menu.schedule.items || menu.schedule.items.length === 0) {
                return true;
              }
              const timeZone = storeTimeZone || "America/Toronto";
              const now = new Date(new Date().toLocaleString("en-US", { timeZone }));
              return isInSchedule(menu.schedule.items, now, 0);
            }
          });
          const visibleMenus = await getVisibleMenus(filteredMenus, sid);
          if (visibleMenus.length === 1) {
            const referrerParam = to.query.referrer ? { referrer: to.query.referrer } : {};
            const targetRoute = {
              name: 'store',
              params: {
                sid,
                mid: visibleMenus[0].code,
                restaurantSlug: store.getters.getStore.slug,
                ...referrerParam
              },
              query: {
                ...to.query,
                skipBeforeEnter: true
              }
            };
            
            localStorage.setItem('forcePopup', JSON.stringify(true));
            if (referrerParam || to.query.referrer) {
              localStorage.setItem('forcePopupReferral', JSON.stringify(true));
            }
            
            next(targetRoute);
            return;
          }
          const metaInfo = setMetaInfo(store, to);
          to.meta.metaInfo = metaInfo;
          next();
          
        } catch (error) {
          console.error('Error in menu-selection beforeEnter:', error);
          if (error.response && error.response.data && error.response.data.errorCode === 'GENERAL_ERR_STORE_NOT_FOUND') {
            next({ name: '404' });
          } else {
            const metaInfo = setMetaInfo(store, to);
            to.meta.metaInfo = metaInfo;
            next();
          }
        }
      }
    },
    {
      path: path('/detail/:gid/:sid/m/:mid'),
      name: 'store1',
      component: () => import(/* webpackChunkName: "store-page" */ './views/StorePage.vue'),
      meta: {
        auth: false,
        manifest: true
      },
      // beforeEnter(to, from, next) {
      //   const metaInfo = setMetaInfo(store, to);
      //   to.meta.metaInfo = metaInfo;
      //   store.dispatch("ensureStoreCart");
      //   store.dispatch("fetchShoppingCart");
      //   store.dispatch("fetchAccountDetails", to.params.sid);
      //   next();
      // }
      beforeEnter(to, from, next) {
        store.dispatch('fetchStore', {
          gid: to.params.gid,
          sid: to.params.sid,
          mid: to.params.mid
        }).then(() => {
          const metaInfo = setMetaInfo(store, to);
          to.meta.metaInfo = metaInfo;
          // Carts are indexed by store, so there is no need to reset the cart depending on the store IDs
          store.dispatch('ensureStoreCart')
          // store.dispatch("fetchShoppingCart");
          store.dispatch('setGroupStore', { gid: to.params.gid })
          store.dispatch('fetchAccountDetails', to.params.sid)
          //return next({ name: 'store', params: { gid: store.getters.getStore.groupId, sid: store.getters.getStore.storeId } })
          next()
        }).catch(error => {
          if (error.response && error.response.data && error.response.data.errorCode === 'GENERAL_ERR_STORE_NOT_FOUND') {
            next({
              name: '404'
            })
          } else {
            console.error('Error fetching store:', error)
            next()
          }
        })
      }
    },
    {
      path: path('/r/:restaurantSlug/:sid/:mid'),
      name: 'store',
      component: () => import(/* webpackChunkName: "store-page" */ './views/StorePage.vue'),
      meta: {
        auth: false,
        manifest: true
      }
      ,
      beforeEnter(to, from, next) {
        if (to.query.tid) {
          store.dispatch("setTableId", to.query.tid)
            .then(() => {
              store.dispatch("setOrderType", "DINE_IN");
              store.dispatch("ensureStoreCart");
              store.dispatch("fetchShoppingCart");
              store.dispatch("fetchAccountDetails", to.params.sid);
              next();
            });
        } else {
          store.dispatch("ensureStoreCart");
          store.dispatch("fetchShoppingCart");
          store.dispatch("fetchAccountDetails", to.params.sid);
          next();
        }
      }
    },
    {
      path: path('/snappy/detail/:gid/:sid/account'),
      name: 'store-account',
      component: () => import(/* webpackChunkName: "store-account-page" */ './views/StoreAccountPage.vue'),
      meta: {
        auth: true,
        manifest: true,
        pageTitle: 'Account Details'
      },
      beforeEnter(to, from, next) {
        const menus = get(store, "getters.getAllMenus", []);
        if (menus == null) {
          store.dispatch("fetchAllMenus");
          next()
        } else {
          next()
        }
      }
    },
    {
      path: path('/snappy/detail/:gid/:sid/guest_history'),
      name: 'guest-history',
      component: () => import(/* webpackChunkName: "guest-order-history" */ './views/GuestOrderHistory.vue'),
      meta: {
        auth: false,
        pageTitle: 'Order History'
      }
    },
    {
      path: path('/snappy/detail/:gid/:sid/checkout'),
      name: 'checkout',
      component: () => import(/* webpackChunkName: "checkout-page" */ './views/CheckoutPage.vue'),
      meta: {
        auth: false,
        manifest: true,
        hideLocation: true,
        pageTitle: 'Checkout'
      },
      beforeEnter(to, from, next) {
        store.dispatch('fetchShoppingCart').finally(() => {
          const metaInfo = setMetaInfo(store, to);
          to.meta.metaInfo = metaInfo;
          next()
        })
      }
    },
    {
      path: path('/snappy/al/:gid/scan/:sid/:tid'),
      name: 'scan-table',
      async beforeEnter(to, from, next) {
        function waitForTableId(maxTries = 10, delay = 50) {
          return new Promise((resolve) => {
            let tries = 0;
            function check() {
              if (to.params.tid || (store.getters.getTableId && store.getters.getTableId !== -1)) {
                resolve(true);
              } else if (++tries >= maxTries) {
                resolve(false);
              } else {
                setTimeout(check, delay);
              }
            }
            check();
          });
        }
        await store.dispatch('setDeliveryAddress', null);
        await store.dispatch('resetCart');
        await store.dispatch("setTableId", to.params.tid);
        await store.dispatch("setOrderType", "DINE_IN");
        await store.dispatch('fetchStore', {
          gid: to.params.gid,
          sid: to.params.sid
        });
        await waitForTableId();
        try {
          const restaurantSlug = store.getters.getStore.slug;
          const sid = to.params.sid;
          const tid = to.params.tid;
          const queryParams = { ...to.query };
          if (tid) {
            queryParams.tid = tid;
          }
          const queryString = Object.keys(queryParams).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`).join('&');
          const path = `/r/${encodeURIComponent(restaurantSlug)}/${encodeURIComponent(sid)}${queryString ? '?' + queryString : ''}`;
          if (to.path === path) {
            return next();
          }
          next(path);
        } catch (err) {
          console.error('[scan-table redirect error]', err);
          next(false);
        }
      }
    },
    {
      path: path('/snappy/detail/:gid/:sid/success_handler'),
      name: 'wechat-handler',
      component: () => import(/* webpackChunkName: "wee-chat-page" */ './views/WeChatHandlerPage.vue'),
      meta: {
        auth: false,
        manifest: true,
        pageTitle: 'WeChat Pay'
      }
    },
    {
      path: path('/snappy/detail/:gid/:sid/3ds_success_handler'),
      name: 'stripe-handler',
      component: () => import(/* webpackChunkName: "wee-chat-page" */ './views/StripeHandlerPage.vue'),
      meta: {
        auth: false,
        manifest: true,
        pageTitle: 'Stripe Pay'
      }
    },
    {
      path: path('/snappy/detail/:gid/:sid/feature'),
      name: 'link-handler',
      component: () => import(/* webpackChunkName: "home-page" */ './views/LinkHandler.vue'),
      meta: {
        auth: false,
        manifest: true,
        pageTitle: 'Link Handler'
      }
    },
    {
      path: path('/404'),
      name: '404',
      component: () => import(/* webpackChunkName: "not-found-page" */ './views/NotFoundPage.vue'),
      meta: {
        auth: false,
        pageTitle: '404 - Page Not Found'
      }
    },
    {
      path: '*',
      redirect: {
        name: '404'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.params = to.params
  if (to.query.direct === 'true' && from.name === 'group') {
    return next();
  }
  const excludePages = ['menu-selection', 'store', 'group', '404']

  if (!get(store, 'getters.getStore.storeId', null) && !excludePages.includes(to.name)) {
    const gid = get(to, 'params.gid', null)
    const sid = get(to, 'params.sid', null)
    
    // Validate that we have valid parameters before making API calls
    if (!gid || !sid || gid === 'null' || sid === 'null') {
      next({
        name: '404'
      })
      return
    }
    
    store.dispatch('fetchStore', {
      gid: gid,
      sid: sid
    }).then(() => {
      next()
    }).catch(error => {
      if (error.response && error.response.data && error.response.data.errorCode === 'GENERAL_ERR_STORE_NOT_FOUND') {
        next({
          name: '404'
        })
      } else {
        console.error('Error fetching store in beforeEach:', error)
        next({
          name: '404'
        })
      }
    })
  } else {
    next()
  }
})

let manifestGID = 0
router.beforeEach(authGuard)
router.beforeEach((to, from, next) => {
  // Reset the local cart if the store id has changed
  const nextStoreId = get(to, 'params.sid', null)
  const curStoreId = get(store, 'getters.getStoreId', null)
  if (to.query.direct === 'true' && from.name === 'group') {
    if (nextStoreId && curStoreId) {
      store.dispatch('resetCart')
      store.commit('clearCheckoutInfo')
      store.commit('CLEAR_TABLE_ID')
      store.commit('SET_PAYMENT_TYPE', null)
    }
    store.dispatch('setDefaultCheckoutInfoIfEmpty')
    return next();
  }
  if (nextStoreId != curStoreId) {
    // Only reset the cart if there was an old store to replace
    // This was causing issues in that the shopping cart was being called too early
    if (nextStoreId && curStoreId) {
      store.dispatch('resetCart')
      store.commit('clearCheckoutInfo')
      store.commit('CLEAR_TABLE_ID')
      store.commit('SET_PAYMENT_TYPE', null)
    }

    store.dispatch('setDefaultCheckoutInfoIfEmpty')
  }
  let sid = to.params.sid || get(store, "getters.getStoreId", null);
  if (
    to.name == "guest-history" ||
    (to.meta && to.meta.manifest && to.params.gid !== manifestGID) ||
    nextStoreId != curStoreId
  ) {
    store
      .dispatch("fetchStoreDetails", { sid, mid: to.params.mid })
      .then((res) => {
        if (res && res.storeGroup) {
          manifestGID = res.storeGroup.groupId
        }

        if (res && res.storeGroup) {
          setGroupTouchIcon(res.storeGroup.groupId)
        }
        if (
          to.name == "guest-history" ||
          to.name == "store-account" ||
          (to.name == "store" && !to.query.skipBeforeEnter)
        ) {
          const metaInfo = setMetaInfo(store, to);
          to.meta.metaInfo = metaInfo;
          store.dispatch("ensureStoreCart");
          Vue.nextTick(() => {
            setTimeout(() => {
              store.dispatch("fetchShoppingCart");
              if (res && res.storeGroup) {
                store.dispatch("setGroupStore", { gid: res.storeGroup.groupId });
              }
            }, 50);
          })
        }
        if (sid) {
          store.dispatch("fetchAccountDetails", to.params.sid);
        }
      })
      .finally(() => {
        next();
      });
  } else {
    if (to.name == "store" && !to.query.skipBeforeEnter) {
      if (!sid) {
        console.warn('Missing required params for store route:', { sid });
        next({
          name: '404'
        });
        return;
      }
      
      store
        .dispatch("fetchStoreDetails", { sid, mid: to.params.mid })
        .then((res) => {
          const metaInfo = setMetaInfo(store, to);
          to.meta.metaInfo = metaInfo;
          if (res && res.storeGroup) {
            store.dispatch("setGroupStore", { gid: res.storeGroup.groupId });
          }
        })
        .catch((error) => {
          console.error('Error fetching store details:', error);
          if (error.code === 'GENERAL_ERR_STORE_NOT_FOUND') {
            next({
              name: '404'
            });
            return;
          }
          next({
            name: '404'
          });
          return;
        });
    }
    if (sid) {
      store.dispatch("fetchAccountDetails", to.params.sid);
    }
    next();
  }
  // if (to.meta && to.meta.manifest && to.params.gid !== manifestGID) {
  //   console.log(store)
  //   store.dispatch('fetchDynamicManifest', to.params.gid).then(() => {
  //     manifestGID = to.params.gid

  //     let link = document.getElementsByTagName('link')
  //     let oldLinks = _.find(link, (o) => o.attributes.rel.value === 'apple-touch-icon')
  //     document.head.removeChild(oldLinks)
  //     var list = [ 'icon-72x72', 'icon-96x96', 'icon-128x128', 'icon-144x144', 'icon-152x152', 'icon-192x192' ]

  //     for (let i = 0; i < list.length; i++) {
  //       let newLink = document.createElement('link')
  //       newLink.rel = 'apple-touch-icon'
  //       newLink.href = '/img/' + to.params.gid + '/' + list[ i ] + '.png'
  //       document.head.appendChild(newLink)
  //     }
  //   }).finally(() => {
  //     next()
  //   })
  // } else {
  //   next()
  // }
})

// Hold on to specific query params (referrer, grp) across route changes.
// We don't want to store these in Vuex state since they're only relevant while using
// the specific link -- but Vue Router has a known bug where navigating to an
// "identical" route (e.g. during login) silently strips existing query params.
// Exported (pure, no router/store deps) so it can be unit tested in isolation.
export const STICKY_QUERY_PARAMS = ['referrer', 'grp']

// One-shot opt-out for code paths that intentionally drop a sticky param on purpose
// (e.g. GroupOrderJoinDialog's clearGrpParam(), closing/invalidating an invite) --
// without this, the guard below can't tell that apart from the Vue Router bug it
// exists to work around, and would fight the deliberate removal.
let skipStickyQueryGuardOnce = false
export function allowStickyQueryParamDrop() {
  skipStickyQueryGuardOnce = true
}

export function resolveStickyQueryRedirect(to, from) {
  var droppedParams = STICKY_QUERY_PARAMS.filter(function(key) { return from.query[key] && !to.query[key] })
  if (!droppedParams.length) return null
  if (to.path === from.path) {
    // This is a no-no via the documentation, but a bug in routing to identical routes strips query params, and this prevents that
    return 'skip'
  }
  return {
    path: to.path,
    query: {...to.query, ...from.query}
  }
}

router.beforeEach((to, from, next) => {
  if (skipStickyQueryGuardOnce) {
    skipStickyQueryGuardOnce = false
    next()
    return
  }

  var redirect = resolveStickyQueryRedirect(to, from)
  if (redirect === 'skip') return
  if (redirect) {
    next(redirect)
    return
  }

  next()
})

// Auto-lock/unlock host's cart based on current page.
// Checkout page → lock host cart via readyCart. Any other page → unlock host cart.
// This handles all navigation paths (back button, direct URL, browser history).
router.afterEach((to) => {
  const groupOrderState = store.state.groupOrder
  if (!groupOrderState || !groupOrderState.isHost || !store.getters['groupOrder/isInGroupOrder']) return

  const hostCartOrderId = groupOrderState.participantCartOrderId
  if (!hostCartOrderId) return

  const isLocked = store.getters['groupOrder/myCartLocked']

  if (to.name === 'checkout') {
    store.dispatch('groupOrder/lockAllCarts')
      .then(function() { return store.dispatch('fetchGroupOrderBillView') })
      .catch(function() {})
  } else {
    store.dispatch('groupOrder/unlockAllCarts').catch(function() {})
  }
})

export default router